/** Unique data-slot names in a template, sorted. */
export function slotsEnHtml(html: string): string[] {
  const names = new Set<string>();
  const re = /data-slot="([^"]+)"/g;
  let m: RegExpExecArray | null;
  while ((m = re.exec(html))) {
    const name = m[1];
    if (name) names.add(name);
  }
  return Array.from(names).sort();
}

/** Returns an error string when HTML slots and manifest slots differ. */
export function validarSlots(html: string, slotNames: string[]): string | null {
  const htmlSlots = slotsEnHtml(html);
  const manifest = [...slotNames].sort();
  if (htmlSlots.join('\n') !== manifest.join('\n')) {
    return `HTML [${htmlSlots.join(', ')}] ≠ manifest [${manifest.join(', ')}]`;
  }
  return null;
}

export function parseFormato(formato: string): { width: number; height: number } {
  const [w, h] = formato.split('x').map((n) => Number(n));
  if (!w || !h) return { width: 1080, height: 1350 };
  return { width: w, height: h };
}
